<template>
<div>
  <div class="d-flex justify-content-center mb-3">
    <ul class="nav nav-pills">
      <li class="nav-item">
        <router-link
          to="/faturamento/visao"
          class="nav-link"
          :class="ativo == 'visao' ? 'active' : ''"
        >Visão Geral</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/faturamento/guias"
          class="nav-link"
          :class="ativo == 'guias' ? 'active' : ''"
        >Guias</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/faturamento/pendencias"
          class="nav-link"
          :class="ativo == 'pendencias' ? 'active' : ''"
        >Pendências</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/faturamento/faturas"
          class="nav-link"
          :class="ativo == 'faturas' ? 'active' : ''"
        >Faturas</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/faturamento/retorno"
          class="nav-link"
          :class="ativo == 'arquivo-retorno' ? 'active' : ''"
        >Arquivo Retorno</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/faturamento/guias/cancelamento"
          class="nav-link"
          :class="ativo == 'autorizar-cancelamentos' ? 'active' : ''"
        >Autorizar Cancelamento</router-link>
      </li>
      <li class="nav-item">
        <div class="btn-group dropleft">
          <button class="btn btn-light dropdown-toggle" type="button" id="triggerId" data-toggle="dropdown" aria-haspopup="true"
                  aria-expanded="false">
              <i class="fas fa-ellipsis-h ml-2"></i>
          </button>
          <div class="dropdown-menu" aria-labelledby="triggerId">
            <router-link to="/faturamento/notas-fiscais" class="dropdown-item" :class="ativo == 'notas-fiscais' ? 'active' : ''">Notas Fiscais</router-link>
            <router-link to="/faturamento/glosas" class="dropdown-item" :class="ativo == 'glosas' ? 'active' : ''">Posição de Recebimentos/Glosas</router-link>
            <router-link to="/faturamento/creditos" class="dropdown-item" :class="ativo == 'creditos' ? 'active' : ''">Créditos de Operadoras</router-link>
            <router-link to="/faturamento/receb-nao-ident" class="dropdown-item" :class="ativo == 'receb-nao-ident' ? 'active' : ''">Recebimentos não Identificados</router-link>
            <router-link to="/faturamento/precos" class="dropdown-item" :class="ativo == 'precos' ? 'active' : ''">Preços</router-link>
            <router-link to="/faturamento/info" class="dropdown-item" :class="ativo == 'info' ? 'active' : ''">Informações</router-link>
            <router-link to="/faturamento/ciha" class="dropdown-item" :class="ativo == 'ciha' ? 'active' : ''">CIHA</router-link>
          </div>
        </div>
      </li>
    </ul>
  </div>

  <klingo-pendencia />
</div>
</template>

<script>
import KlingoPendencia from '../../shared/KlingoPendencia.vue';

export default {
  props: ["ativo"],

  components: { 
    KlingoPendencia, 
  }
};
</script>